'use client'

import { useFirstLoginCheck } from '@app/hooks'

export function useGreeting(name: string) {
  const isFirstLogin = useFirstLoginCheck()
  let firstName = name.split(' ')[0]

  firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase() // Capitalization

  return isFirstLogin ? `Welcome, ${firstName}` : `Welcome back, ${firstName}`
}
